import { AsideMenuItem } from './aside-menu-item';
import { AsideMenuItemWithSub } from './aside-menu-item-with-sub';
import { Loading } from 'components/loading';
import { useAuth } from 'features/auth/contexts/auth';
import { Page } from 'features/shared/model';
import { useMemo } from 'react';

export function AsideMenuMain() {
  const { isGranted, currentPermissions } = useAuth();

  const canReadVehicleInspection = isGranted(Page.VehicleInspection, 'read');
  const canReadWorkshopDayPlanner = isGranted(Page.WorkshopPlanner, 'read');
  const canReadVHCRecords = isGranted(Page.VHCRecords, 'read');
  const canReadServicePrices = isGranted(Page.ServicePrices, 'read');
  const canReadTechnicianEfficiencyReport = isGranted(Page.TechnicianEfficiencyReport, 'read');
  const isServiceAdvisorsAccessible = useMemo(() => isGranted(Page.SalesBranchKPIs, 'read'), [isGranted]);
  const isConfigurationAccessible = useMemo(() => isGranted(Page.ServiceAdvisors, 'read'), [isGranted]);
  const canReadWorkshopCheckInLog = useMemo(() => isGranted(Page.WorkshopCheckInLog, 'read'), [isGranted]);
  const canReadWorkshopLog = useMemo(() => isGranted(Page.WorkshopLog, 'read'), [isGranted]);
  const canReadDigitalWip = useMemo(() => isGranted(Page.DigitalWip, 'read'), [isGranted]);
  const canReadWarrantyLog = useMemo(() => isGranted(Page.WarrantyLog, 'read'), [isGranted]);

  return currentPermissions ? (
    <>
      <div className="text-gray-400 mb-7 fs-7 text-uppercase">SERVICE & PARTS</div>

      {canReadDigitalWip && <AsideMenuItem to="/digital-wip" icon="/media/icons/custom/list.svg" title="Digital WIP" />}

      {isConfigurationAccessible && (
        <AsideMenuItem
          to="/advisors-commissions"
          icon="/media/icons/custom/book.svg"
          title="Service Advisors Commissions"
        />
      )}

      <AsideMenuItem
        to="/collection-and-delivery"
        icon="/media/icons/custom/cube-3.svg"
        title="Collection & Delivery"
      />

      {isServiceAdvisorsAccessible && (
        <AsideMenuItem to="/service-advisors" icon="/media/icons/custom/book-open2.svg" title="Service Advisors KPIs" />
      )}

      <AsideMenuItemWithSub to="/service-prices" title="Service Prices" icon="/media/icons/custom/price-tag.svg">
        {canReadServicePrices && <AsideMenuItem to="/service-prices/service-prices" hasBullet title="Service Prices" />}
        <AsideMenuItem to="/service-prices/jobs" hasBullet title="Jobs" />
        <AsideMenuItem to="/service-prices/parts-availability" hasBullet title="Parts Availability" />
      </AsideMenuItemWithSub>

      {canReadTechnicianEfficiencyReport && (
        <AsideMenuItemWithSub
          to="/technicians-reports"
          title="Technicians Report"
          icon="/media/icons/custom/delivery-logistics-red.svg"
        >
          <AsideMenuItem to="/technicians-reports/efficiency-report" title="Efficiency Report " hasBullet />
          <AsideMenuItem to="/technicians-reports/qs-report" title="Efficiency Report QS" hasBullet />
          <AsideMenuItem
            to="/technicians-reports/technician-utilization-time"
            hasBullet
            title="Technician Utilization Time"
          />
          <AsideMenuItem
            to="/technicians-reports/branch-efficiency-report"
            hasBullet
            title="Branch Efficiency report QS"
          />
        </AsideMenuItemWithSub>
      )}

      {canReadVehicleInspection && (
        <AsideMenuItem
          to="/vehicle-inspection"
          icon="/media/icons/custom/files-folders-ch.svg"
          title="Vehicle Inspection"
        />
      )}

      <AsideMenuItemWithSub to="/vhc" title="VHC" icon="/media/icons/custom/list.svg">
        {canReadVHCRecords && <AsideMenuItem to="/vhc/record" title="VHC Records" hasBullet />}
        <AsideMenuItem to="/vhc/statistics" title="VHC Statistics" hasBullet />
        <AsideMenuItem to="/vhc/quote-stats" title="Quote Stats" hasBullet />
        <AsideMenuItem to="/deferred-work" title="Deffered reminders" hasBullet />
      </AsideMenuItemWithSub>

      <AsideMenuItemWithSub to="/vehicle-preparation" title="Vehicle Preparation" icon="/media/icons/custom/list.svg">
        <AsideMenuItem to="/vehicle-preparation/check" title="Vehicle Preparation Check" hasBullet={true} />
      </AsideMenuItemWithSub>

      <AsideMenuItem to="/video-log" icon="/media/icons/custom/youtube.svg" title="Video Log" />

      {canReadWorkshopDayPlanner && (
        <AsideMenuItem
          to="/workshop-day-planner"
          icon="/media/icons/custom/files-folders-ch.svg"
          title="Workshop Day Planner"
        />
      )}

      <AsideMenuItem
        to="/team-performance"
        icon="/media/icons/custom/delivery-logistics-red.svg"
        title="BDC Team Performance"
      />

      {canReadWorkshopCheckInLog && (
        <AsideMenuItemWithSub to="/workshop-check-in" title="Workshop Check In" icon="/media/icons/custom/list.svg">
          <AsideMenuItem to="/workshop-check-in/log" title="Workshop Check In Log" hasBullet={true} />
          <AsideMenuItem to="/workshop-check-in/new" title="New Workshop Check In" hasBullet={true} />
        </AsideMenuItemWithSub>
      )}

      <AsideMenuItem to="/notification-types" icon="/media/icons/custom/bell.svg" title="Notification Types" />
      <AsideMenuItem to="/recalls" icon="/media/icons/custom/recall.svg" title="Recall" />
      <AsideMenuItem to="/service-booking-log" icon="/media/icons/custom/it-network.svg" title="Service Booking Log" />

      <AsideMenuItem to="/workshop-loading" icon="/media/icons/custom/book.svg" title="Workshop Loading" />

      {canReadWorkshopLog && (
        <AsideMenuItem to="/workshop-log" icon="/media/icons/custom/it-network.svg" title="Workshop Log" />
      )}

      {canReadWarrantyLog && (
        <AsideMenuItem to="/warranty-logs" icon="/media/icons/custom/it-network.svg" title="Warranty Log" />
      )}
    </>
  ) : (
    <Loading />
  );
}
